/**
 * Test whether a thing is a plain JS object
 *
 * @param {any} obj The object to test
 * @returns {boolean} true if a plain object
 */
export default function isObject(obj) {
    return obj && !Array.isArray(obj) && typeof obj == 'object';
}
//# sourceMappingURL=is-object.js.map